import axios from "axios";
const { VITE_API_URL } = import.meta.env;

export interface ErrorDetail {
  loc: string[]; // Location of the error in the request
  msg: string; // Error message
}

export interface ErrorType {
  data: any;
  response?: {
    data?: {
      detail?: string | ErrorDetail[]; // Supports both string and array formats
      message?:string;
    };
  };
}

const client = axios.create({
  baseURL: VITE_API_URL,
});

export async function loginEmail(email: string,domain: string) {
  return await client.post(
    "users/otp/generate",
    { email,domain },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  );
}

export async function loginUser(identifier: string, org_id: number,domain:string) {
  return await client.post(
    "customers/otp/generate",
    { identifier, org_id,domain },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  );
}

export async function createUser(its_id: string, org_id: number,domain:string) {
  return await client.post(
    "customers/otp/create-user",
    { its_id, org_id,domain },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  );
}

export async function customerOtpVerify(email: string, otp: string, fcm_token:string,its_id:string,domain:string) {
  return await client.post(
    "customers/otp/verify",
    {
      email,
      otp,
      fcm_token,
      its_id,
      domain
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  );
}

export async function OtpVerify(email: string, otp: string,domain:string) {
  return await client.post(
    "users/otp/verify",
    {
      email,
      otp,
      domain
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    }
  );
}

export async function getUserResource(role_id: number, token: string) {
  try {
    const response = await client.get(`role/${role_id}`, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
      },
    });
    return response;
  } catch (error) {
    const err = error as ErrorType;

    let errorMessage: string;

    if (Array.isArray(err.response?.data?.detail)) {
      // Extract field names and messages
      errorMessage = err.response?.data?.detail
        .map((d) => `${d.loc.slice(-1)[0]}: ${d.msg}`)
        .join("; ");
    } else if (typeof err.response?.data?.detail === "string") {
      errorMessage = err.response?.data?.detail;
    } else {
      errorMessage = "Something went wrong";
    }

    console.error("Error logging in:", errorMessage);
    throw new Error(errorMessage);
  }
}
